export default __webpack_public_path__ + "static/media/subscription-success-icon.9625fbae.svg";